export default "__VITE_ASSET__acae4911__"